import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Language } from 'itcores-fw';


declare let $: any;
declare let layout: any;

@Component({
  selector: 'app-root-layout',
  templateUrl: './root-layout.component.html',
  styleUrls: ['./root-layout.component.css']
})
export class RootLayoutComponent implements OnInit {
  lang: Language;
  items: any[];

  constructor(
    router: Router // private breadcrumb: BreadcrumbService
  ) {
    router.events.subscribe(val => {
      // console.log(val);
      //console.log(val instanceof NavigationEnd)
      // if (val instanceof NavigationEnd) {
      //   let routes = val.url.split('/');
      //   this.items = routes.map(i => {
      //     return {
      //       label: i ? i : 'Home',
      //       url: '#'
      //     };
      //   });
      // }
    });
  }

  ngOnInit() {
    // window.addEventListener('scroll', this.scrolling, true);
    layout();
    // tabSlider();
    // to make menu minimize by defualt
    // $('.m-page--fluid').addClass('m-brand--minimize m-aside-left--minimize');
    $('.m-menu__item--submenu .m-menu__item').on('click', function () {
      $('body, .m-grid__item').removeClass('m-aside-left--on');
    });
    this.changeDir();
  }
  changeDir() {
    let checkLang = localStorage.getItem('lang')
    checkLang === 'ar' ? document.body.dir = 'rtl' : document.body.dir = 'ltr';
  }
  // radio choose 
  // isColor = 'default';
  // customerModeChanged(createMode: string) {
  //   this.isColor = createMode || 'default' || 'dark';
  // }
  // default() {
  //   document.documentElement.style.setProperty('--mainbackground', '#fff');
  //   document.documentElement.style.setProperty('--mainColor', '#205a30');
  //   console.log("default");
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('userThemeBackColor', '#fff');
  // }
  // dark() {
  //   document.documentElement.style.setProperty('--mainbackground', '#000');
  //   document.documentElement.style.setProperty('--mainColor', '#a3a3a3');
  //   console.log("dark");
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('userThemeBackColor', '#fff');
  // }
  // background(event) {
  //   document.documentElement.style.setProperty('--mainbackground', event.target.value);
  //   console.log(event.target.value);
  //   // Save the value for next time page is visited.
  //   localStorage.setItem('userThemeBackColor', event.target.value);
  // }
  // color(event) {
  //   // Theme the site!
  //   document.documentElement.style.setProperty('--mainColor', event.target.value);
  //   console.log(event.target.value);
  //   // Save the event.target.value for next time page is visited.
  //   localStorage.setItem('userThemeColor', event.target.value);
  // }


  scrolling(e) {
    let sc = e.srcElement.scrollTop;
    if (sc >= 150) {
      console.log('scrolling = ' + sc);

      $('.public-data').addClass('fullwidth-data');
      $('.list-icons-default').addClass('remove-margin');
      $('.page-header-body ').removeClass('show');
    }

    if (sc <= 0) {
      $('.public-data').removeClass('fullwidth-data');
      $('.list-icons-default').removeClass('remove-margin');
      $('.page-header-body ').addClass('show');
    }
  }
}
